<script setup lang="ts">
import Add from "@/core/components/icons/Add.vue";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger
} from "@/core/components/ui/dropdown-menu";
import {Dog} from "@lucide/vue";

defineEmits(['addProgram', 'addPet']);
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger class="text-sm">
      <Add :size="16" color="gray-300" />
      Ajouter
    </DropdownMenuTrigger>
    <DropdownMenuContent class="min-w-40 text-sm cursor-pointer">
      <DropdownMenuItem class="cursor-pointer" @click="$emit('addProgram')">
        <Add :size="16" color="gray-300" /> Ajouter un programme
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem class="cursor-pointer" @click="$emit('addPet')">
        <Dog :size="16" class="text-gray-300" /> Ajouter un animal
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
